import React, { useState, useEffect } from "react"
import { get, put } from "@rails/request.js"
import { Table, Tag, Space, Button, message, Modal } from "antd"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import PreviewImage from "components/common/PreviewImage"
import { toQuery } from "utils/query"
const { confirm } = Modal
import AddNewButton from "components/common/AddNewButton"

function NewsList(): JSX.Element {
  const [news, setNews] = useState([])
  const [tailMark, setTailMark] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [loading, setLoading] = useState(true)

  const fetchNews = async (params = {}) => {
    if (!params["tail_mark"]) {
      params["tail_mark"] = tailMark || 1
    }
    const response = await get(`/api/v1/admin/news?${toQuery(params)}`)
    if (response.ok) {
      const parsedData = await response.json
      setNews(parsedData.items)
      setTotalCount(parsedData.meta.total_count)
      setTailMark(parsedData.meta.tail_mark)
      setLoading(false)
    }
  }

  const columns = [
    {
      title: "编号",
      dataIndex: "id",
      key: "id",
      width: 100,
    },
    {
      title: "封面",
      key: "cover",
      width: 100,
      render: (item) => (
        item.cover ? (
          <PreviewImage
            src={item.cover}
            width={240}
            height={60}
            title={item.name}
          />
        ) : (
          "-"
        )
      ),
    },
    {
      title: "标题",
      key: "title",
      render: (item) => (
        <span>
          {item.title}{" "}
          <Tag color={item.status_color}>{item.status_name}</Tag>
        </span>
      ),
    },
    {
      title: "描述",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "操作",
      key: "action",
      width: 150,
      render: (item) => (
        <Space size={[8, 16]} wrap>
          <a
            href={`/admin/news/${item.id}/edit`}
            className="ant-btn ant-btn-sm">
            编辑
          </a>
          {item.status === "normal" && (
            <Button
              size="small"
              onClick={() => updateNewsStatus(item.id, "blocked")}>
              屏蔽
            </Button>
          )}
          {item.status === "blocked" && (
            <Button
              size="small"
              onClick={() => updateNewsStatus(item.id, "normal")}>
              取消屏蔽
            </Button>
          )}
        </Space>
      ),
    },
  ]

  const handleTableChange = (pagination, filters, sorter) => {
    const params = { tail_mark: pagination.current }
    fetchNews(params)
  }

  const updateNewsStatus = async (id, status) => {
    confirm({
      title: `请确认 ${
        status === "blocked" ? "屏蔽" : "取消屏蔽"
      } 编号为 ${id} 的用户吗？`,
      icon: <ExclamationCircleOutlined />,
      okText: "确定",
      cancelText: "取消",
      async onOk() {
        const response = await put(`/api/v1/admin/news/${id}`, {
          body: JSON.stringify({ status }),
        })

        if (response.ok) {
          message.success("更新成功")
          const u = news.find((pd) => pd.id === id)
          u.status = status
          u.status_name = status === "blocked" ? "屏蔽" : "正常"
          u.status_color = status === "blocked" ? "red" : "green"
          setNews([...news])
        } else {
          message.success("更新失败")
        }
      },
      onCancel() {
        console.log("Cancel")
      },
    })
  }

  useEffect(() => {
    fetchNews()
  }, [])

  return (
    <>
      <AddNewButton url="/admin/news/new" name="添加新的资讯" />
      <Table
        bordered
        loading={loading}
        columns={columns}
        pagination={{
          pageSize: 20,
          total: totalCount,
          showQuickJumper: true,
          showSizeChanger: false,
        }}
        rowKey="id"
        style={{ wordBreak: "keep-all" }}
        tableLayout="fixed"
        dataSource={news}
        onChange={handleTableChange}
      />
    </>
  )
}

export default NewsList
